import { api } from './index';

/**
 * Fetches all invoice templates for a specific organization.
 * @param {object} requestParams
 * @param {number} requestParams.orgId - The id of the org to get the template from.
 * @returns {Promise} - the request
 */
export const fetchInvoiceTemplates = async ({ orgId }) => {
  return api.get(`/api/organization/${orgId}/templates/invoices`);
};

export const createInvoiceFromLead = async ({
  isTemplate = false,
  orgId,
  templateId,
  lead_id: leadId,
  ...rest
}) => {
  const payload = { ...rest, lead_id: leadId };
  const baseUrl = `/api/organization/${orgId}/invoices-by-lead/${leadId}`;
  if (isTemplate) {
    return api.post(
      `${baseUrl}?add_invoice_from_template`,
      { ...payload, template_id: templateId },
    );
  }
  return api.post(baseUrl, payload);
};

export const fetchNextInvoiceIdentifier = ({ orgId }) => {
  return api.get(`/api/organization/${orgId}/next-invoice-identifier`);
};
